import { Skeleton } from '@/_config/lib/react-native-skeleton';
import styles from './confirm-mission-modal.module.scss';

export const ConfirmMissionModalSkeleton = () => {
  return (
    <div className={styles.loadingState} aria-busy="true" aria-live="polite">
      <Skeleton height={20} width="55%" borderRadius={8} />

      <div className={styles.infoCard}>
        <Skeleton height={20} width="70%" borderRadius={8} />
      </div>

      <div className={styles.detailsCard}>
        <div className={styles.detailRow}>
          <div className={styles.detailGroup}>
            <Skeleton height={16} width={180} borderRadius={6} />
            <Skeleton height={16} width={200} borderRadius={6} />
          </div>
        </div>

        <div className={styles.detailRow}>
          <div className={styles.detailGroup}>
            <Skeleton height={16} width={140} borderRadius={6} />
            <Skeleton height={16} width={160} borderRadius={6} />
          </div>
        </div>

        <div className={styles.detailRow}>
          <div className={styles.detailGroup}>
            <Skeleton height={16} width={170} borderRadius={6} />
            <Skeleton height={16} width={150} borderRadius={6} />
          </div>
        </div>

        <Skeleton height={16} width="85%" borderRadius={6} />
      </div>

      <div className={styles.infoCard}>
        <Skeleton height={20} width="50%" borderRadius={8} />
      </div>
    </div>
  );
};
